import Phaser from 'phaser';

import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { BlocksMainScene } from '../../scenes/blocks-main-scene';
import { Subscription } from 'rxjs';
import { LevelControlViewModel } from './level-control-view-model';
import GameMetrics from 'src/games/phaserblocks/logic/helpers/game-metrics';
import { TextResizer } from '../grid/text-resizer';

export class LevelControlView extends Phaser.GameObjects.Container {
  private subscriptionGroup: Subscription;
  private textResizer: TextResizer;

  private levelTitleLabel: Phaser.GameObjects.Text;
  private levelLabel: Phaser.GameObjects.Text;

  constructor(
    scene: BlocksMainScene,
    x: number,
    y: number,
    private viewModel: LevelControlViewModel,
  ) {
    super(scene, x, y);

    this.subscriptionGroup = new Subscription();
    this.textResizer = new TextResizer(scene, this, {
      fontFamily: 'Inter',
      fontSize: '50px',
      fontStyle: 'bold',
      color: '#ffffff',
    });

    this.levelTitleLabel = this.scene.add
      .text(0, 0, this.viewModel.levelLabelText, {
        fontFamily: 'Inter',
        fontSize: '40px',
        fontStyle: 'bold',
        color: '#b2b2b2',
      })
      .setOrigin(0.5, 0.5);
    this.add([this.levelTitleLabel]);

    this.levelLabel = this.scene.add
      .text(0, 0, `1/${GameMetrics.MaxStage - 1}`, {
        fontFamily: 'Inter',
        fontSize: '40px',
        fontStyle: 'bold',
        color: '#ffffff',
      })
      .setOrigin(0.5, 0.5);
    this.add([this.levelLabel]);

    this.setName(LevelControlView.name);
    scene.add.existing(this);

    this.subscriptionGroup.add(
      this.viewModel.showControl$.subscribe((showControl) => {
        this.setVisible(showControl);
      }),
    );
    this.subscriptionGroup.add(
      this.viewModel.onGameSetupStart$.subscribe(() => {
        this.viewModel.onGameSetupStart();
      }),
    );
    this.subscriptionGroup.add(
      this.viewModel.onResetGameScene$.subscribe(() => {
        this.levelLabel.text = `1/${GameMetrics.MaxStage - 1}`;
      }),
    );
    this.subscriptionGroup.add(
      this.viewModel.blocksLogicActionBus$.subscribe((actionBus) => {
        if (!actionBus) {
          return;
        }
        actionBus.on('onLevelChanged', (payload) => {
          this.levelLabel.text = `${payload.value}/${GameMetrics.MaxStage - 1}`;
        });
      }),
    );
  }

  override destroy(_fromScene?: boolean | undefined): void {
    this.subscriptionGroup.unsubscribe();

    super.destroy(_fromScene);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    const layoutConfig = this.viewModel.layoutConfig;
    const calc = this.viewModel.calculateScaleFactor(gameSizeMetrics);

    const cellSz = (layoutConfig.boardWidth - layoutConfig.cellBorder) / 9;
    const innerCellSz = cellSz - layoutConfig.cellBorder;
    const controlWidth = (cellSz * 3 - layoutConfig.cellBorder) * calc.scaleFactor;
    const controlHeight = layoutConfig.controlsHeight * calc.scaleFactor;

    const xPos = (innerCellSz + layoutConfig.cellBorder) * 8 - innerCellSz * 0.5;
    const yPos = controlHeight * 0.5;

    this.setPosition(
      (layoutConfig.hMargin + xPos) * calc.scaleFactor + calc.scaledOffsetX,
      (layoutConfig.controlsMargin + yPos) * calc.scaleFactor,
    );
    this.setSize(controlWidth, controlHeight);

    const fontSize = this.textResizer.fitText('XXXXXXXXXXXX', controlWidth, 14);
    this.levelTitleLabel.setFontSize(fontSize);
    this.levelLabel.setFontSize(fontSize);

    const spacing = controlHeight * 0.3;
    this.levelTitleLabel.setX(-spacing * 0.5 - this.levelLabel.displayWidth * 0.5);
    this.levelLabel.setX(spacing * 0.5 + this.levelTitleLabel.displayWidth * 0.5);
  }
}
